import React from "react";
import { Container } from "react-bootstrap";

const SteqeymaHCP = ({
  shouldHideDiv,
  collapseText,
  isiTextRef,
  readLess,
}) => {
  return (
    <>
      <div
        className={`isi-text-sticky isi-text ${shouldHideDiv ? "d-none" : ""}`}
      >
        <Container className="position-relative">
          <button className="isi-text-open" onClick={collapseText}>
            <i className="fas fa-plus fa-icon"></i>
          </button>
          <div className="isi-text-wrap">
            <br />
            <p>
              <strong>INDICATIONS AND IMPORTANT SAFETY INFORMATION</strong>
            </p>
            <p>
              <strong>INDICATIONS</strong>
            </p>
            <p>
              STEQEYMA is a prescription medicine used to treat:
            </p>
            <p>
              <ul>
                <li>
                  <strong>
                    moderate or severe psoriasis
                  </strong>&nbsp;
                  in adults and children
                  6 years and older who may benefit from taking
                  injections or pills (systemic therapy) or phototherapy
                  (treatment using ultraviolet light alone or with pills).
                </li>
                <li>
                  <strong>
                    active psoriatic arthritis
                  </strong>&nbsp;
                  in adults and children 6 years and older.
                </li>
                <li>
                  <strong>
                    moderately to severely active Crohn’s disease
                  </strong>&nbsp;
                  in adults.
                </li>
                <li>
                  <strong>
                    moderately to severely active ulcerative colitis
                  </strong>&nbsp;
                  in adults.
                </li>
                <p>It is not known if STEQEYMA is safe and effective in children less than 6 years of age. </p>
                <p><strong>Do not take STEQEYMA if you</strong>are allergic to ustekinumab products or any of the ingredients in STEQEYMA.  </p>
              </ul>
            </p>
          </div>
        </Container>
      </div>

      <div className="isi-text" ref={isiTextRef}>
        <Container className="position-relative">
          <div className="isi-text-wrap">
            <button onClick={readLess} className="isi-text-open">
              <i class="fas fa-times fa-icon"></i>
            </button>
            <p className="isi-first-text">
              <strong>INDICATIONS AND IMPORTANT SAFETY INFORMATION</strong>
            </p>
            <br />
            <p>
              <strong>INDICATIONS</strong>
            </p>
            <p>
              STEQEYMA is a prescription medicine used to treat:
            </p>
            <ul>
              <li>
                <strong>
                  moderate or severe psoriasis
                </strong>&nbsp;
                in adults and children
                6 years and older who may benefit from taking
                injections or pills (systemic therapy) or phototherapy
                (treatment using ultraviolet light alone or with pills).
              </li>
              <li>
                <strong>
                  active psoriatic arthritis
                </strong>&nbsp;
                in adults and children 6 years and older.
              </li>
              <li>
                <strong>
                  moderately to severely active Crohn’s disease
                </strong>&nbsp;
                in adults.
              </li>
              <li>
                <strong>
                  moderately to severely active ulcerative colitis
                </strong>&nbsp;
                in adults.
              </li>
            </ul>
            <p>It is not known if STEQEYMA is safe and effective in children less than 6 years of age. </p>
            <p><strong>Do not take STEQEYMA if you</strong> are allergic to ustekinumab products or any of the ingredients in STEQEYMA.  </p>
            <br />
            <p>
              <strong>IMPORTANT SAFETY INFORMATION </strong>
            </p>
            <ul>
              <li>
                <strong>
                  Serious infections.
                </strong>
                <p>
                  STEQEYMA affects your immune system and can increase the risk of serious infections, including tuberculosis (TB), bacterial, fungal, and viral infections. Some infections may require hospitalization.
                </p>
              </li>
            </ul>
            <p><strong>Before starting STEQEYMA: </strong></p>
            <ul>
              <li>
                <p>
                  Your doctor will test you for TB.
                </p>
              </li>
              <li>
                <p>
                  If you're at risk for TB, you may need treatment before and during STEQEYMA.
                </p>
              </li>
              <li>
                <p>
                  <strong>Tell your doctor if you:</strong>
                </p>
                <ul>
                  <li>
                    <p>Have an infection or signs of infection: fever, chills, cough, muscle aches, shortness of breath, weight loss, blood in phlegm, tiredness, diarrhea, stomach pain, skin sores, or burning when urinating. </p>
                  </li>
                  <li>
                    Are being treated for an infection or have any open cuts.
                  </li>
                  <li>
                    Get frequent or recurring infections.
                  </li>
                  <li>
                    Have TB or have been exposed to TB.
                  </li>
                  <li>
                    Ever had an allergic reaction to ustekinumab products.
                  </li>
                  <li>
                    Recently had or plan to get vaccines (you must avoid live vaccines, including the BCG vaccine during treatment and for a year afterward).
                  </li>
                  <li>
                    Have new or changing lesions within psoriasis areas or on normal skin.
                  </li>
                  <li>
                    Are receiving or have received allergy shots or phototherapy.
                  </li>
                  <li>
                    Are pregnant, planning to become pregnant, or breastfeeding. STEQEYMA can pass into breast milk.
                  </li>
                  <li>
                    Received STEQEYMA while pregnant, inform your baby’s healthcare provider before they get vaccinations.
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  <strong>Tell your doctor about all the medicines you take,</strong> including prescription and over-the-counter medicines, vitamins, and herbal supplements. Know all the medicines, vitamins, and supplements you take, and share them with your doctor.
                </p>
              </li>
            </ul>
            <br />
            <p>
              <strong>After starting STEQEYMA:</strong>
            </p>
            <p>
              Call your doctor right away if you develop symptoms of an infection, such as chest infections, skin infections, or shingles. STEQEYMA can increase the risk of infections or make existing infections worse.
            </p>
            <p>
              <strong>Cancers</strong>
            </p>
            <p>
              STEQEYMA may increase the risk of certain cancers, including skin cancer. Tell your doctor if you have a history of cancer or notice any new skin growths during treatment.
            </p>
            <p>
              <strong>Posterior Reversible Encephalopathy Syndrome (PRES)</strong>
            </p>
            <p>
              PRES is a rare but serious brain condition that can cause death. Symptoms include headache, confusion, seizures, and vision problems. Contact your doctor immediately if these occur.
            </p>
            <p>
              <strong>Serious Allergic Reactions.</strong>
            </p>
            <p>
              Serious allergic reactions can occur with STEQEYMA. Stop using STEQEYMA and get medical help right away if you have any of the following symptoms of a serious allergic reaction: feeling faint, chest tightness, swelling of your face, eyelids, tongue, or throat, or a skin rash.
            </p>
            <p>
              <strong>Lung Inflammation.</strong>
            </p>
            <p>
              Cases of lung inflammation have happened in some people who receive ustekinumab products and may be serious. These lung problems may need to be treated in a hospital. Tell your doctor right away if you develop shortness of breath or a cough that doesn’t go away during treatment with STEQEYMA.
            </p>
            <p>
              <strong>Common Side Effects of STEQEYMA. </strong>
            </p>
            <p>
              Common side effects of STEQEYMA include nasal congestion, sore throat, and runny nose; upper respiratory infections; fever; headache; tiredness; itching; nausea and vomiting; redness at the injection site; vaginal yeast infections; urinary tract infections; sinus infection; bronchitis; diarrhea; and stomach pain.             </p>
            <p><strong>These are not all of the possible side effects of STEQEYMA. Call your doctor for medical advice about side effects.  </strong></p>
            <p>You may report side effects to FDA at 1-800-FDA-1088. You may also report side effects to CELLTRION USA, Inc. at 1-800-560-9414. </p>
            <p>
              <br/ ><br/ ><strong>For more information about STEQEYMA, please see full <a href="https://www.accessdata.fda.gov/drugsatfda_docs/label/2024/761338s000lbl.pdf" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline', color: 'black' }}>Prescribing Information</a>.</strong>
            </p>
          </div>
        </Container>
      </div>
    </>
  );
};

export default SteqeymaHCP;
